import { render, staticRenderFns } from "./account-set.html?vue&type=template&id=dc6b7904&scoped=true&external"
import script from "./account-set.js?vue&type=script&lang=js&external"
export * from "./account-set.js?vue&type=script&lang=js&external"
import style0 from "./account-set.scss?vue&type=style&index=0&id=dc6b7904&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6b7904",
  null
  
)

export default component.exports